import React from 'react';

const portraitStyles: React.CSSProperties = {
    maxHeight: '100%',
    maxWidth: '100%',
    width: 'auto',
    height: 'auto',
    display: 'block',
    margin: '0 auto',
    objectFit: 'contain' as const,
    borderRadius: '4px',
    objectPosition: 'center',
};

const landscapeStyles: React.CSSProperties = {
    maxWidth: '100%',
    maxHeight: '100%',
    width: 'auto',
    height: 'auto',
    objectFit: 'contain' as const,
    borderRadius: '4px',
    objectPosition: 'center',
};

const RenderMediaModal = (
    post: any,
    checkImgExt: boolean,
    checkVideoExt: boolean,
    ref: any,
    t: (key: string) => string,
    carouselIndicators?: {
        total: number;
        activeIndex: number;
        onSelect: (index: number) => void;
    },
) => {
    const mediaContent = checkVideoExt ? (
        <video
            src={post.cdnMediaUrl}
            ref={ref}
            style={post.width > post.height ? landscapeStyles : portraitStyles}
            controls
            preload="auto"
        />
    ) : checkImgExt ? (
        <img
            src={post.cdnMediaUrl}
            style={post.width > post.height ? landscapeStyles : portraitStyles}
            alt=""
            ref={ref}
        />
    ) : (
        <div
            className="gds-card__img gds-flex -text-center gds-flex--justify-center gds-flex--direction-col"
            style={{
                alignItems: 'center',
                alignContent: 'center',
                width: '100%',
                height: '100%',
                maxHeight: '400px',
            }}
            ref={ref}
        >
            <i className="fal fa-images" />
            <p>{t('socialMediaExposure.postModal.noMediaAvailable')}</p>
        </div>
    );

    return (
        <div
            className="modal-v2-media-wrapper"
            style={{ height: '400px', maxHeight: '400px' }}
        >
            <div
                className="modal-v2-media-inner"
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    maxHeight: '400px',
                }}
            >
                {mediaContent}
                {carouselIndicators?.total > 1 && (
                    <div className="modal-v2-carousel-indicators">
                        {Array.from({ length: carouselIndicators.total }).map(
                            (_, index) => (
                                <button
                                    aria-label={`Show carousel slide ${index + 1}`}
                                    className={`modal-v2-carousel-indicator${
                                        index === carouselIndicators.activeIndex
                                            ? ' modal-v2-carousel-indicator--active'
                                            : ''
                                    }`}
                                    key={index}
                                    onClick={() =>
                                        carouselIndicators.onSelect(index)
                                    }
                                    type="button"
                                />
                            ),
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};
export default RenderMediaModal;
